import React from "react";
import Form from "../ui/Form";

interface LoginFormProps {
  handleSubmit: (data: any) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({ handleSubmit }) => {
  return (
    <Form
      fields={[
        {
          label: "Email",
          name: "email",
          type: "email",
          placeholder: "Enter Email address",
          validations: {
            required: true,
          },
        },
        {
          label: "Password",
          name: "password",
          type: "password",
          placeholder: "Enter your password",
          validations: {
            required: true,
          },
        },
      ]}
      onSubmit={handleSubmit}
      submitLabel="Login"
    />
  );
};

export default LoginForm;
